import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "bulma/css/bulma.css";

ReactDOM.render(<App />, document.getElementById("root"));
